<template>
        <v-flex xs12 sm8 md8 lg8>
              <gen-img-uploader
                  :autoLoad="true"
                  path="quoteImages"
                  @imageLinkFound="addImageLink"
                  @removeImage="removeImageLink">
              </gen-img-uploader>
            <div v-if="mediaUrl">
              <v-img :src=mediaUrl></v-img>
              <app-loading v-if="loading"></app-loading>
              <!--              <map style="border-style: solid; border-color: greenyellow" name="annonMap" id="annonMap">-->
              <!--&lt;!&ndash;                <div v-for="obj in annonObj" :key="obj.id" >{{obj.name}} = {{obj.boundingPoly.normalizedVertices}}</div>&ndash;&gt;-->
              <!--                <area alt="Computer" target="" coords="20,500,81,200" shape="rect" >-->
              <!--              </map>-->
            </div>
        </v-flex>
</template>
<script>
import {collection, onSnapshot} from "firebase/firestore";
// import {getAuth, onAuthStateChanged} from "firebase/auth";
import { getFunctions, httpsCallable  } from 'firebase/functions';
import {v1 as uuidv1} from "uuid";

export default {
  props: ['publicListingId', 'listingId'],
  data: () => ({
    mediaUrl: undefined,
    annotatedImage: null,
    annonObj: null,
    itemId: 'autoImgRecognition',
    itemType: 'mlItem',
    addOnItems: null,
    detectedItems: null,
    annotatedImages: null

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  mounted () {
    let db = this.$store.state.db
    let itemsRef = collection(db, 'publicListings',
        this.publicListingId + '/listings/' + this.listingId + '/addOnItems')
    onSnapshot(itemsRef, res => {
      console.log(res)
      if (res && res.empty !== true) {
        let items = []
        let sortedItems = []
        res.forEach(doc => {
          let data = doc.data()
          items.push(data)
        })
        console.log(items)
        sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
        this.addOnItems = sortedItems
      }
      this.$store.dispatch('setLoading', false)
    })
  },
  methods: {
    removeImageLink() {
      this.mediaUrl = undefined
    },
    addImageLink(link) {
      //console.log(link)
      let detectedItems = []
      this.$store.dispatch('setLoading', true)
      this.mediaUrl = link.url
      const functions = getFunctions()
      const annotateImage = httpsCallable(functions, 'annotateImageToItems')
      annotateImage({fileName: link.imgLocation})
          .then(res => {
            if (res.data) {
              return res.data.annotatedImage
            }
          })
          .then(annotatedImages => {
           // console.log(annotatedImages)
            if (annotatedImages) {
              let objects = annotatedImages.objects
              console.log(objects)
              if (this.addOnItems) {
                console.log(this.addOnItems)
                let items = this.addOnItems
                objects.forEach(object => {
                  let matchedItem = items.find(item => {
                    return object.name === item.title
                  })
                  if (matchedItem) {
                    let mlObject = matchedItem
                    mlObject.mlObject = true
                    mlObject.normalizedVerticies = object.boundingPoly.normalizedVertices
                    mlObject.score = object.score
                    mlObject.imgs = [{id: link.id, url: link.url}]
                    mlObject.qty = 1
                    detectedItems.push(mlObject)
                  } else {
                    let item = {
                      created: Date.now(),
                      customItem: false,
                      id: object.mid,
                      mlObject: true,
                      normalizedVerticies: object.boundingPoly.normalizedVertices,
                      score: object.score,
                      imgs:[{id: link.id, url: link.url}],
                      instruction: '',
                      kmPrice: 0,
                      listed: false,
                      minutePrice: 30,
                      note: '',
                      qty: 1,
                      title: object.name,
                      unitPrice: 0
                    }
                    detectedItems.push(item)
                  }
                })
                return detectedItems
                //console.log(detectedItems)
              }
            }
          })
          .then(detectedItems => {
            if (detectedItems) {
              return this.$emit('itemsRecovered', detectedItems)
            } else {
              return this.$store.dispatch('setError', {message: "Auto detection failed. Let's try again"})
            }
          })
          .then(() => {
            this.$store.dispatch('setLoading', true)
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setError', err)
          })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

